export default "__VITE_PUBLIC_ASSET__26d0f776__"